<template lang="pug">
  .login-account
    .error(v-if="errorMsg") {{ errorMsg }}
    .loading(v-if="loading")
      p Checking email...
    .login-form
    form(v-if="!forgot" v-on:keyup="checkSubmit")
        label User Email
          input(type="text" v-model="accountInfo.email" placeholder="email address")
        label Password
          input(type="password" v-model="accountInfo.password" placeholder="password")
          a.forgot(@click="forgot = true") Forgot Password
        button(type="button" @click="submitLogin") Sign In

    form(v-else v-on:keyup="checkSubmit")
        label User Email
          input(type="text" v-model="accountInfo.email" placeholder="email address")
        button(type="button" @click="forgotPassword") Send Password Reset
        p.login 
          a(@click="forgot = false") I already have an account
</template>

<script>
import connect from "../scripts/database.js";
import { Quotes } from "../scripts/quotes.js";
import Activity from "../scripts/activity.js";
import Accounts from "../scripts/accounts.js";

export default {
  name: "LoginForm",
  data() {
    return {
      errorMsg: "",
      accountInfo: {
        email: "",
        password: ""
      },
      loading: false,
      forgot: false
    };
  },
  computed: {
    emailValid: function() {
      if (this.accountInfo.email) {
        return !!this.accountInfo.email.match(/.+@.+\..+/g);
      } else {
        return false;
      }
    }
  },
  methods: {
    submitLogin: function() {
      this.loading = true;
      this.errorMsg = "";
      connect.auth
        .signInWithEmailAndPassword(
          this.accountInfo.email,
          this.accountInfo.password
        )
        .then(results => {
          this.loading = false;
          this.$root.currentUser = {
            name: results.user.name,
            uid: results.user.uid,
            guest: false
          };

          // Save Guest Draft Quote
          if (
            sessionStorage.getItem("draft_quotes") &&
            sessionStorage.getItem("draft_quotes") !== "undefined"
          ) {
            var session = JSON.parse(sessionStorage.getItem("draft_quotes"));
            if (this.$parent.quote && this.$parent.quote.deliveryTimeframe) {
              session.deliveryTimeframe = this.$parent.quote.deliveryTimeframe;
            }
            session.forUser = results.user.uid;
            Quotes.createQuote(session);
            this.$root.activeDraft = session;

            if (this.$parent.$options.name == "Authentication") {
              this.$root.currentState = "quotes";
            } else if (this.$parent.$options.name == "Cart") {
              this.$root.currentState = "draft";
              this.$parent.addressState = "existing-account";
              this.$parent.getAccount();
            }
          } else {
            this.$root.currentState = "quotes";
          }

          Accounts.updateLastLogin(this.$root.currentUser);
          Activity.userActivity(
            { name: results.user.displayName, uid: results.user.uid },
            "user:signin",
            {
              name: results.user.displayName,
              email: results.user.email,
              uid: results.user.uid
            }
          );
        })
        .catch(error => {
          this.errorMsg = error.message;
          this.loading = false;
        });
    },
    forgotPassword() {
      this.loading = true;
      this.errorMsg = "";
      if (this.emailValid) {
        connect.auth
          .sendPasswordResetEmail(this.accountInfo.email)
          .then(() => {
            console.log("password reset sent");
            this.$root.confirmation.msg = "Password Reset Email Sent";
            this.$root.confirmation.returnState = "quotes";
            this.$root.confirmation.returnMsg = "View Account";
            this.$root.confirmation.open = true;
            this.forgot = false;
            this.loading = false;
          })
          .catch(error => {
            this.errorMsg = "No account found at email address";
            this.loading = false;
          });
      } else {
        this.errorMsg = "Email address is not valid";
        this.loading = false;
      }
    },
    checkSubmit(e) {
      if (e && e.keyCode == 13) {
        this.submitLogin();
      }
    }
  },
  created: function() {
    this.$root.currentPage = "Log In";
  }
};
</script>

<style lang="scss">
@import "../assets/styles/variables.scss";

#app {
  .error {
    margin-top: 1em;
  }

  .login-account {
    .loading {
      margin: 1em 0;
    }
    form {
      margin: 1em 0;

      label {
        font-size: 0.9em;
      }

      label.tax-exempt {
        font-size: 0.8em;
      }

      input {
        border: 1px $border_gray solid;
        border-radius: 7px;
        margin: 1em 0;
        padding: 1em 0.5em;
        width: 100%;
      }
      a.forgot {
        display: inline-block;
        font-size: 13px;
        margin-bottom: 2em;
      }
    }
  }
}
</style>
